import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TnvedHeadingSearchResult {
  code: string;
  /** 2 = глава, 4 = товарная позиция */
  level: number;
  name: string;
  /** Близость к запросу (косинусное сходство), чем больше — тем ближе */
  similarity: number;
}

export interface TnvedResolveResult {
  code: string | null;
  codeName: string | null;
  full: boolean;
  /** Как ИИ понял товар */
  productDescription: string | null;
  /** AI — ИИ по подсказкам, TREE — спуск по дереву, NONE — не найден */
  source: 'AI' | 'TREE' | 'NONE';
  hints: TnvedHeadingSearchResult[];
  /** true — результат взят из кэша (одна и та же пара название+описание всегда даёт один и тот же код) */
  cached: boolean;
}

@Injectable({ providedIn: 'root' })
export class TnvedHeadingService {
  private readonly API_URL = '/cargo/api/tnved/heading-search';

  constructor(private http: HttpClient) {}

  resolve(name: string, description: string, refresh = false): Observable<TnvedResolveResult> {
    const params = new HttpParams().set('name', name).set('description', description).set('refresh', refresh);
    return this.http.get<TnvedResolveResult>('/cargo/api/tnved/resolve', { params });
  }

  search(query: string, limit = 20): Observable<TnvedHeadingSearchResult[]> {
    const params = new HttpParams().set('query', query).set('limit', limit);
    return this.http.get<TnvedHeadingSearchResult[]>(this.API_URL, { params });
  }
}
